{
  "(optional)": "(optional)",
  "(required)": "(erforderlich)"
}